//The param is enumerable in Rails so each value corresponds to an index: high_priority: 0 low_priority: 1 working: 2 stalled: 3 closed: 4
export const DEAL_WORKING_STATUS = {
	HIGH: 'high_priority',
	WORKING: 'working',
	LOW: 'low_priority',
	STALLED: 'stalled',
	CLOSED_DEALS: 'closed',
	HAS_COMMENTS: 'has_comments',
	ABSOLUTE_SALE: 'absolute_sale',
};

export const TOGGLE_GROUP_OPTIONS = [
	{
		key: DEAL_WORKING_STATUS.HIGH,
		label: 'High',
		value: '0',
	},
	{
		key: DEAL_WORKING_STATUS.WORKING,
		label: 'Working',
		value: '2',
	},
	{
		key: DEAL_WORKING_STATUS.HAS_COMMENTS,
		label: 'Comments',
		value: '5',
	},
	{
		key: DEAL_WORKING_STATUS.LOW,
		label: 'Low',
		value: '1',
	},
	{
		key: DEAL_WORKING_STATUS.STALLED,
		label: 'Stalled',
		value: '3',
	},
	{
		key: DEAL_WORKING_STATUS.ABSOLUTE_SALE,
		label: 'Absolute',
		value: '6',
	},
	{
		key: DEAL_WORKING_STATUS.CLOSED_DEALS,
		label: 'Closed',
		value: '4',
	},
];

export const DEAL_WORKER_ALL_FILTER = '0';

export const DEAL_DRIVER_TABS = {
	ALL_DEALS: 'all_deals',
	DISCOUNTS: 'discounts',
};

export const DEAL_DRIVER_TAB_OPTIONS = [
	{
		key: DEAL_DRIVER_TABS.ALL_DEALS,
		label: 'All deals',
	},
	{
		key: DEAL_DRIVER_TABS.DISCOUNTS,
		label: 'Discounts',
	},
];

export const DISCOUNT_STATUS_FILTERS = {
	REQUESTED: 'pending',
	READY: 'ready',
	APPROVED: 'approved',
	COMPLETED: 'completed',
	NA: 'na',
	DENIED: 'denied',
};

export const DISCOUNT_STATUS_VARIANTS = {
	SUCCESS: 'success',
	WARNING: 'warning',
	ALERT: 'alert',
};

export const DEFAULT_DISCOUNT_STATUS_FILTER = [];

export const DISCOUNT_STATUS_FILTER_OPTIONS = [
	{
		key: DISCOUNT_STATUS_FILTERS.REQUESTED,
		label: 'Requested',
	},
	{
		key: DISCOUNT_STATUS_FILTERS.READY,
		label: 'Ready to apply',
		variant: DISCOUNT_STATUS_VARIANTS.WARNING,
	},
	{
		key: DISCOUNT_STATUS_FILTERS.APPROVED,
		label: 'Approved',
		variant: DISCOUNT_STATUS_VARIANTS.SUCCESS,
	},
	{
		key: DISCOUNT_STATUS_FILTERS.COMPLETED,
		label: 'Applied',
		variant: DISCOUNT_STATUS_VARIANTS.SUCCESS,
	},
	{
		key: DISCOUNT_STATUS_FILTERS.NA,
		label: 'Closed - N/A',
	},
	{
		key: DISCOUNT_STATUS_FILTERS.DENIED,
		label: 'Denied',
		variant: DISCOUNT_STATUS_VARIANTS.ALERT,
	},
];

export const DEAL_RESPONSIBILITY_FILTER = [
	{
		key: 'Buying',
		label: 'Buying',
		value: '0',
	},
	{
		key: 'Selling',
		label: 'Selling',
		value: '1',
	},
];

export const DYNAMIC_SEARCH_DEBOUNCE = 1000;

export const EXPAND_ALL_TOGGLE_STATES = {
	expanded: 'expanded',
	collapsed: 'collapsed',
};
